import { Component } from 'react';
import { RouteComponentProps, StaticContext, withRouter } from 'react-router';
import OrderLogListItem from '../../components/OrderLogListItem/OrderLogListItem';
import { defaultPagination } from 'src/constants/main';
import { localeStore } from 'src/mobx/localesStore';
import client from 'src/services/client';
import { IPagination } from 'src/types/main';
import { TOrderLog } from 'src/types/orders';
import { formatDate } from 'src/utils/helpers';
import Pagination from 'src/view/components/Controls/PaginationOld/PaginationOld';
import ScrollableBlock from 'src/view/containers/ScrollableBlock/ScrollableBlock';
import './style.scss';
import logger from '~/services/logger';

type TProps = RouteComponentProps<{ id: string }, StaticContext, undefined>;

interface State {
  pagination: IPagination<TOrderLog | undefined>;
}

interface IItem {
  text: string;
  className?: string;
}

const RenderHeaderItem = (item: IItem) => {
  return (
    <p className={`family-medium color-gray2 text-size-12 text-uppercase letter-spacing-12 ${item.className || ''}`}>{localeStore.t(item.text)}:</p>
  );
};

class OrderLogsList extends Component<TProps, State> {
  state = {
    pagination: defaultPagination,
  };

  componentDidMount = () => {
    this.fetchList();
  };

  fetchList = async (page: number = this.state.pagination.current_page + 1) => {
    try {
      if (typeof page !== 'number') page = this.state.pagination.current_page + 1;

      this.setState((state) => ({ pagination: { ...state.pagination, loading: true, refreshing: true } }));
      const pagination: IPagination<TOrderLog> = await client.get(`/v3/orders/${this.props.match.params.id}/logs`, {
        params: { page, details: 1, action: 'status_change' },
      });
      this.setState({ pagination: { ...pagination, loading: false, refreshing: false, data: pagination.data } });
    } catch (error: any) {
      this.setState((state) => ({ pagination: { ...state.pagination, loading: false, refreshing: false } }));
      logger.error({ error, place: 'OrderLogsList fetchList' });
    }
  };

  getStatus = (status: string | undefined): string => {
    return status ? localeStore.t(`${status}_status`) : '-';
  };

  renderLog = (log: TOrderLog | undefined, index: number) => {
    return (
      <ul key={index} className="order-log-list__string d-flex flex-row">
        <OrderLogListItem text={log?.id} skeletonWidth={60} className="w-7" />
        <OrderLogListItem text={log?.status} skeletonWidth={170} className="w-15 text-elipsis" />
        <OrderLogListItem
          text={log ? formatDate(log.time * 1000, { includeSecond: true, militaryFormat: true }) : undefined}
          skeletonWidth={170}
          className="w-19"
        />
        <OrderLogListItem text={log?.json.author} skeletonWidth={150} className="w-15 text-wrap-anywhere" />
        <OrderLogListItem text={log ? this.getStatus(log.json.old_status) : undefined} skeletonWidth={150} className="w-15" />
        <OrderLogListItem text={log ? this.getStatus(log.json.new_status) : undefined} skeletonWidth={150} className="w-15" />
        <OrderLogListItem text={log ? log.notes || '-' : undefined} skeletonWidth={150} className="w-14" />
      </ul>
    );
  };

  render() {
    return (
      <div className="order-log-list d-flex flex-1 flex-column px-8 pb-8 pt-6">
        <div className="d-flex flex-row mb-4">
          <RenderHeaderItem text="order_id" className="w-7" />
          <RenderHeaderItem text="order_actions" className="w-15" />
          <RenderHeaderItem text="txt_Time" className="w-19" />
          <RenderHeaderItem text="author" className="w-15" />
          <RenderHeaderItem text="old_status" className="w-15" />
          <RenderHeaderItem text="new_status" className="w-15" />
          <RenderHeaderItem text="notes" className="w-14" />
        </div>
        <ScrollableBlock className="d-flex flex-1 mb-2">{this.state.pagination.data.map(this.renderLog)}</ScrollableBlock>

        <Pagination pagination={this.state.pagination} onChange={this.fetchList} />
      </div>
    );
  }
}

export default withRouter(OrderLogsList);
